export default __webpack_public_path__ + "static/media/etrade.a4016de2.svg";